import { Production, ProductionInput } from 'sr-types/lib/production/v1/graphql';
import { toInput } from '../production/helpers/productionApi';

export const getRawAttributesFromValues = (associatedFieldDefinitionReferences, attributes) => {
    const raw = associatedFieldDefinitionReferences?.map((fd) => {
        const updatedAttributes = attributes?.find((attr) => attr.fieldDefinitionReference.id === fd.id);
        return {
            ...updatedAttributes,
            fieldDefinitionReference: fd
        };
    });
    return raw || [];
};

export const getNewAttributes = ({ existingAttributes = [], newAttributes = [] }) => {
    const updatedAttributes = existingAttributes ? [...existingAttributes] : [];

    for (const attr of newAttributes) {
        const index = updatedAttributes.findIndex((p) => p.fieldDefinitionReference.id === attr.id);

        if (index !== -1) {
            updatedAttributes[index].value = attr.value;
        } else {
            updatedAttributes.push({
                fieldDefinitionReference: attr.reference,
                fieldType: attr.fieldType,
                name: attr.name,
                value: attr.value
            });
        }
    }

    return { updatedAttributes };
};

export const getNewAssociatedFieldDefinitionReferences = ({
    existingAssociatedFDReferences = [],
    attributeIds,
    fieldDefinitions
}) => {
    const associatedFieldDefinitionReferences = existingAssociatedFDReferences
        ? [...existingAssociatedFDReferences]
        : [];

    for (const fd of fieldDefinitions) {
        if (attributeIds.includes(fd.reference.id)) {
            associatedFieldDefinitionReferences.push(fd.reference);
        }
    }

    return { associatedFieldDefinitionReferences };
};

export const getUpdatedAttAndFDRefAfterAttributeDeletion = ({ values, fieldDefinitionId }) => {
    const { associatedFieldDefinitionReferences, attributes } = values;

    const updatedAssociatedFieldDefinitionReferences = associatedFieldDefinitionReferences?.filter(
        (fieldDefinition) => fieldDefinition.id !== fieldDefinitionId
    );
    const updatedAttributes = attributes?.filter((p) => p.fieldDefinitionReference.id !== fieldDefinitionId);

    return { updatedAssociatedFieldDefinitionReferences, updatedAttributes };
};

export const onSaveEntityAfterAttributeEdit = (
    updatedValues: Production & ProductionInput,
    isDeletingAttribute: boolean,
    onSaveProduction: (entity, successMessageToken, failureMessageToken) => Promise<string>,
    entityId: string,
    locale: string,
    isPipeline = false
): Promise<string> => {
    const savedEntity = {
        ...toInput(entityId, updatedValues, locale, undefined, undefined, isPipeline),
        ownerOrganizationId: updatedValues?.ownerOrganizationId,
        ownerOrganizationName: updatedValues?.ownerOrganizationName,
        associatedFieldDefinitionReferences: updatedValues?.associatedFieldDefinitionReferences,
        attributes: updatedValues?.attributes,
        group: updatedValues?.group
    };
    delete savedEntity.ownerOrganization;
    return onSaveProduction(
        savedEntity,
        isDeletingAttribute ? 'attribute.delete.success.message' : 'attributes.save.success.message',
        isDeletingAttribute ? 'attribute.delete.failure.message' : 'attributes.save.failure.message'
    );
};
